// @flow

import React, { Component } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import LeftIndicator from "../LeftIndicator";
import TechnicalCard from "../TechnicalCard";
import MovieSection from "../MovieSection";
import ResponsiveImage from "../ResponsiveImage";
import {
  Accordion,
  AccordionItem,
  AccordionItemState,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel
} from "react-accessible-accordion";
import "./RoofStep2.scss";

export default class RoofStep2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false
    };
  }

  toggleMenu() {
    this.setState({
      menu: !this.state.menu
    });
  }

  closeMenu() {
    this.setState({
      menu: false
    });
  }

  getClosestParent(element, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        (s => {
          var matches = (this.document || this.ownerDocument).querySelectorAll(
              s
            ),
            i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        });
    }

    // Get the closest matching element
    for (; element && element !== document; element = element.parentNode) {
      if (element.matches(selector)) return element;
    }
    return null;
  }

  handleClic2(event) {
    console.log(event.target);
    let parent = this.getClosestParent(event.target, ".accordion__item");
    let activeItems = document.querySelectorAll(".active-acc__item2");
    activeItems.forEach(item => item.classList.remove("active-acc__item2"));
    parent.classList.add("active-acc__item2");
  }

  render() {
    return (
      <React.Fragment>
        <section  id="roof-step2" className="roof-step2">
          <div className="roof-step2_container container row">
            <div className="col-6 col-ml-12 photo-col">
              <ResponsiveImage
                imageName="masa-szpachlowa-small.jpg"
                imageClass={"picture mirror-image"}
              />
            </div>
            <div className="col-6 col-ml-12 roof-photo-description">
              <div className="roof-description-background">
                <p className="h1-white-big">Krok 2</p>
                <p className="h3-red">Szybkie szpachlowanie</p>
                <p className="description-title-white">
                  Masa szpachlowa{" "}
                  <span className="small-title__white ">
                    polimerowo-bitumiczna
                  </span>
                </p>
                <p className="text-basic">
                  Oczyszczone i zagruntowane ubytki w powłoce, wypełniamy i
                  wyrównujemy przy użyciu masy szpachlowej Evomer. Jedna warstwa
                  może mieć grubość do 10 mm.
                </p>
                <p className="text-basic">
                  W przypadku szpachlowania połączeń dwóch różnych materiałów
                  (np. papy i betonu przy kominach wentylacyjnych czy wieńcu)
                  poleca się wzmocnienie szpachli przez zatopienie w niej
                  włókniny poliestrowej, z wywinięciem na każdą stronę. Czas
                  wstępnego schnięcia szpachli Evomer wynosi około
                  <div className="text-important">2 godzin </div> pełne to 2 mm
                  na dobę, w temperaturze otoczenia 20 st. C.
                </p>
              </div>
            </div>
          </div>

          <div className="prepare-surface  row">
            <div className="container logo-title-2">
              <div className="logo-title__wrapper flex-title">
                <img src="/img/evomer-logo-white.png" className="logo-white" />
                <p className="h3-red left-margin__fill">
                  Szybkie szpachlowanie
                </p>
              </div>
            </div>
            <div className="prep-surface__container">
              {/* <div className="indicator-container">
                  <LeftIndicator puttyMass /> 
              </div> */}

              <div className="container surface-pics__container">
                <div className="col-12 surface-pictures row">
                  <MovieSection
                    movie1="../movies/Masa szpachlowa.mp4"
                    image01="../img/masa-szpachlowa-movie.jpg"
                    movie2="../movies/Masa szpachlowa_wersja2.mp4"
                    image02="../img/masa-szpachlowa-movie2.jpg"
                  />
                </div>
              </div>
            </div>

            <div id="fastFillArea" className="col-12 technical-card fast-filling__wrapper">
              <div className="container logo-title">
                <div className="logo-title__wrapper">
                  <img
                    src="/img/evomer-logo-white.png"
                    className="logo-white"
                  />
                  <div className="sub-title__ccontainer">
                    <p className="h3-red">Masa szpachlowa</p>
                    <p className="description-title-white">
                      Polimerowo-bitumiczna
                    </p>
                  </div>
                </div>
              </div>
              <div className="fast-filling__container">
                {/* <div className="indicator-wrapper">
                   <LeftIndicator puttyMass/> 
                </div> */}
                <div className="col-12 selects-wrapper container row">
                  <div className="col-6 col-ml-12 selects ">
                    <div className="selects-container">
                      <Accordion>
                        <AccordionItem>
                          <AccordionItemHeading
                            onClick={this.handleClic2.bind(this)}
                          >
                            <AccordionItemButton>
                              <span className="af-icon-plus visible-icon"></span>
                              <span className="af-icon-minus hidden-icon"></span>
                              Benefity
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <ul className="benefits-list">
                              <li className="list-item">
                                szybkoschnąca i odporna na deszcz – już po 2
                                godzinach
                              </li>
                              <li className="list-item">
                                bezpieczna dla styropianu
                              </li>
                              <li className="list-item">
                                nie zawiera rozpuszczalników – niepalna,
                                bezwonna
                              </li>
                              <li className="list-item">
                                podwyższona odporność na promieniowanie UV do 5
                                lat
                              </li>
                              <li className="list-item">
                                odporna na temperatury – zachowuje elastyczność
                                w -20oC, nie spływa z pionowych powierzchni w
                                tem"p +90oC
                              </li>
                              <li className="list-item">
                                tworzy trwale elastyczne wypełnienie mostkujące
                                rysy do 2 mm
                              </li>
                            </ul>
                          </AccordionItemPanel>
                        </AccordionItem>

                        <AccordionItem>
                          <AccordionItemHeading
                            onClick={this.handleClic2.bind(this)}
                          >
                            <AccordionItemButton>
                              <span className="af-icon-plus visible-icon"></span>
                              <span className="af-icon-minus hidden-icon"></span>
                              Sposób aplikacji
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <h5 className="small-header">
                              Przygotowanie produktu
                            </h5>
                            <p className="acc__para">
                              Produkt jest gotowy do użycia.
                            </p>

                            <h5 className="small-header">
                              Przygotowanie podłoża
                            </h5>
                            <p className="acc__para">
                              Podłoże powinno być wysezonowane czyste, suche lub
                              lekko wilgotne i oczyszczone z tłuszczu i innych
                              czynników zmniejszających przyczepność. Podłoża
                              porowate i pylące zagruntować Szybkim Gruntem
                              Polimerowo-Bitumicznym EVOMER.
                            </p>

                            <h5 className="small-header">Aplikacja</h5>
                            <p className="acc__para">
                              Evomer Masę Szpachlową nakłada się za pomocą
                              szpachli lub pacy.
                            </p>
                          </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                          <AccordionItemHeading
                            onClick={this.handleClic2.bind(this)}
                          >
                            <AccordionItemButton>
                              <span className="af-icon-plus visible-icon"></span>
                              <span className="af-icon-minus hidden-icon"></span>
                              Szpachlowanie
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <ul className="benefits-list">
                              <li className="list-item">
                                Nanosić warstwami o grubości do 10mm.
                              </li>
                              <li className="list-item">
                                Przy wysokich temperaturach i silnym
                                nasłonecznieniu nanosić cieńsze warstwy.
                              </li>
                              <li className="list-item">
                                Jeśli szpachlowanie przebiega na połączeniu
                                dwóch materiałów miejsce należy wzmocnić pasem
                                zatopionej włókniny poliestrowej o gramaturze:
                                ok. 80 g/m2 z wywinięciem po 15cm na każdą
                                stronę.
                              </li>
                              <li className="list-item">
                                Miejsca szpachlowane można pokrywać papą lub
                                masą powłokową Evomer po wyschnięciu.
                              </li>
                              <li className="list-item">
                                Zużycie ok.: 1,2 kg na m2 przy grubości 1mm.
                                Realne zużycie zależne jest od rodzaju prac.
                              </li>
                              <li className="list-item">
                                Czas schnięcia: wstępnie 2 godziny, pełne zależy
                                od grubości wypełnienia – około 2 mm na dobę w
                                temp 20o C
                              </li>
                            </ul>
                          </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                          <AccordionItemHeading
                            onClick={this.handleClic2.bind(this)}
                          >
                            <AccordionItemButton>
                              <span className="af-icon-plus visible-icon"></span>
                              <span className="af-icon-minus hidden-icon"></span>
                              Klejenie
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <ul className="benefits-list">
                              <li className="list-item">
                                Przyklejanie materiałów izolacyjnych i
                                termoizolacyjnych do podłoży z blachy, betonu,
                                papy, izolacji wykonanych z mas bitumicznych.
                              </li>
                              <li className="list-item">
                                Na montażowe strony płyt ocieplających nałożyć
                                punktowo lub pasami Masę Szpachlową EVOMER.
                              </li>
                              <li className="list-item">
                                Odczekać około 10 minut i docisnąć do
                                powierzchni.
                              </li>
                              <li className="list-item">
                                Płyty ocieplające hydrofobizowane przed
                                klejeniem należy przeszlifować.
                              </li>
                              <li className="list-item">
                                Niewłaściwe jest klejenie dużych powierzchni
                                dwóch materiałów niechłonnych np. papa z rolki
                                do blachy lub papy podkładowej.
                              </li>
                            </ul>
                          </AccordionItemPanel>
                        </AccordionItem>
                        <AccordionItem>
                          <AccordionItemHeading
                            onClick={this.handleClic2.bind(this)}
                          >
                            <AccordionItemButton>
                              <span className="af-icon-plus visible-icon"></span>
                              <span className="af-icon-minus hidden-icon"></span>{" "}
                              Dane techniczne
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <div className="table-wrapper">
                              <table>
                                <tbody>
                                  <tr>
                                    <td>Konsystencja</td>
                                    <td>
                                      Masa o konsystencji gęstej, kleistej,
                                      jednorodna, z mikrowłóknami
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Gęstość</td>
                                    <td>1,15 – 1,25</td>
                                  </tr>
                                  <tr>
                                    <td>Zużycie</td>
                                    <td>
                                      1,2 kg na m<sup>2</sup> przy grubości 1mm
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Temperatura aplikacji [°C ]</td>
                                    <td>
                                      1,2 kg na m<sup>2</sup> przy grubości 1mm
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Odporność na deszcz</td>
                                    <td>Po 2 godz.</td>
                                  </tr>
                                  <tr>
                                    <td>Czas schnięcia w temp +5C/50%rh</td>
                                    <td>2mm/ 24godz.</td>
                                  </tr>
                                  <tr>
                                    <td>Temperatura aplikacji [°C ]</td>
                                    <td>+5 +35</td>
                                  </tr>
                                  <tr>
                                    <td>
                                      Elastyczność w niskich temperaturach
                                    </td>
                                    <td>
                                      -20<sup>o</sup>C
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      Odporność na wysoką temperaturę
                                      <br />
                                      (nie spływa z powierzchni pionowych)
                                    </td>
                                    <td>
                                      90<sup>o</sup>C
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </AccordionItemPanel>
                        </AccordionItem>
                      </Accordion>
                    </div>
                    <TechnicalCard
                      pdf={
                        "/pdf/evomer-masa-szpachlowa-01-TDS-Karta-techniczna-produktu.pdf"
                      }
                    />
                  </div>
                  <div className="col-6 col-ml-12  roof-product">
                    <img
                      src="/img/masa-szpachlowa-produkt.png"
                      className="product-large"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RoofStep2/RoofStep2.js